'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeRequest = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _TimeOutError = require('../errors/TimeOutError');

var _TimeOutError2 = _interopRequireDefault(_TimeOutError);

var _ServiceError = require('../errors/ServiceError');

var _ServiceError2 = _interopRequireDefault(_ServiceError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TIME_OUT = 60000;

var makeRequest = function makeRequest(opts) {
  return new _promise2.default(function (resolve, reject) {
    var method = opts.method,
        url = opts.url,
        params = opts.params,
        headers = opts.headers;

    var xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.open(method, url);
    xhr.timeout = TIME_OUT;
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(xhr.response);
      } else {
        reject({
          status: xhr.status,
          statusText: xhr.statusText
        });
      }
    };
    xhr.onerror = function (event) {
      reject({
        status: xhr.status,
        statusText: new _ServiceError2.default('Something went wrong')
      });
    };

    xhr.ontimeout = function () {
      reject({
        statusText: new _TimeOutError2.default('Failed due to time out')
      });
    };

    if (headers) {
      (0, _forEach2.default)(headers, function (value, key) {
        xhr.setRequestHeader(key, value);
      });
    }
    xhr.send(params);
  });
};

exports.makeRequest = makeRequest;